import { z } from 'zod';
import { MarcadorLocal } from './enum';

export const MarcadorSchema = z.object({
    mar_cor: z.string().nullable(),
    mar_empresa_idpk: z.number().int(),
    mar_idpk: z.number().int(),
    mar_locais: z.enum(MarcadorLocal).array().nullable(),
    mar_titulo: z.string().nullable(),
});

export type Marcador = z.infer<typeof MarcadorSchema>;

export type MarcadorBody = Pick<Marcador, 'mar_cor' | 'mar_locais' | 'mar_titulo'>;
